//common helper.js
import CryptoJS from "crypto-js";
import dayjs from "dayjs";

const SECRET = process.env.REACT_APP_ENC_SECRET_KEY;

export const encryptData = (data) => {
  if (!data) return null;
  if (!SECRET) {
    console.error("SECRET KEY MISSING");
    return null;
  }
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET).toString();
  } catch (err) {
    console.error("ENCRYPT ERROR", err);
    return null;
  }
};

export const decryptData = (cipher) => {
  if (!cipher || !SECRET) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    return decrypted ? JSON.parse(decrypted) : null;
  } catch (err) {
    console.error("DECRYPT ERROR", err);
    return null;
  }
};

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/;

export const resolveRowKey = (record) =>
  record.std_id ?? record.st_id ?? record.ss_id ?? record.ssf_id ??
  record.stt_id ?? record.m_id ?? record.l_id ?? record.s_id ?? record.bc_id ?? record.b_id ?? record.exam_id ?? record.admin_id ??
  record.sh_id ?? record.se_id ?? record.ser_id ?? record.ay_id ??
  record.sq_id ?? record.question_id ?? record.answer_id ?? record.sqr_id ??
  record.cmp_id ?? record.id ?? record.sc_id;

// Simple debounce helper
export const debounce = (fn, delay = 400) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

// Reset modal state
export const resetModalState = (setEditData, setIsOpen) => {
  setEditData(null);
  setIsOpen(false);
};

// Convert DD-MM-YYYY -> YYYY-MM-DD
export const formatDateForInput = (str) => {
  if (!str || str === "N/A") return null;
  const [dd, mm, yyyy] = str.split("-");
  return `${yyyy}-${mm}-${dd}`;
};

// Today date helper
export const getTodayDateString = () => new Date().toISOString().split("T")[0];

// Sample taken usernames
export const SAMPLE_USERNAMES = ["ram123", "teacher01", "abc123"];

// Parse dates like "January 26, 2026"
export const parseDisplayDate = (str) =>
  dayjs(str, "MMMM D, YYYY", true).isValid()
    ? dayjs(str, "MMMM D, YYYY")
    : dayjs(str);

export const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "";
  const d =
    dateStr.indexOf("-") === 2 ? dayjs(dateStr, "DD-MM-YYYY") : dayjs(dateStr);
  return d.isValid() ? d.format("MMMM D, YYYY") : dateStr;
};

export const formatToAPIDate = (date) =>
  date ? dayjs(date).format("YYYY-MM-DD") : null;
